module.exports = __webpack_public_path__ + "static/img/MaLie_banner.d8fdb9ca.jpg";